import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=48ab859b&"
import script from "./configurator.vue?vue&type=script&lang=js&"
export * from "./configurator.vue?vue&type=script&lang=js&"
import style0 from "./configurator.vue?vue&type=style&index=0&id=48ab859b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./configurator.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports